import AttendeanceLogs from "@/pages/Attendance/Components/AttendeanceLogs";
import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react"

const Attendance = lazy(() => import("@/pages/Attendance/Attendance"));
const AttendancePage = lazy(() => import("@/pages/Attendance/AttendancePage"));

const AttendanceRoute: RouteConfig = {
    path: "/attendance",
    element: <Attendance />,
    pageName: "Attendance",
    sidebar: { show: true, icon: "/assets/media/attendanceLogo.svg" },
    children: {
        MAIN: {
            path: "",
            element: <AttendancePage />,
            pageName: "Attendance",
            sidebar: { show: false }
        },
        ATTENDENCE_LOG: {
            path: "attendeance-logs",
            element: <AttendeanceLogs />,
            pageName: "Geofence In/Out Log",
            sidebar: { show: false },
        }
    }
}

export default AttendanceRoute;



